import { createAction, props } from '@ngrx/store';
import {
	StatementArticle,
	StatementCategory,
	StatementCategoryDetails,
} from '../../models/statements.models';

//generic failure
export const loadStatementsFailure = createAction(
	'[Statements State] - Load Failure',
	props<any>(),
);

//get statement categories
export const fetchStatementCategories = createAction(
	'[Statements State] - Fetch Categories',
);

export const updateStatementCategories = createAction(
	'[Statements State] - Update Categories',
	props<{ categories: StatementCategory[] }>(),
);

//get statements for specific category
export const fetchStatementsByCategory = createAction(
	'[Statements State] - Fetch Statements for Category',
	(categorySlug = '') => ({ categorySlug }),
);

export const updateStatementsForCategory = createAction(
	'[Statements State] - Update Statements for Category',
	props<{ statements: StatementCategoryDetails; categorySlug: string }>(),
);

//get single statement
export const fetchStatementArticle = createAction(
	'[Statements State] - Fetch Statement Article',
	(categorySlug = '', statementUrl = '') => ({
		categorySlug,
		statementUrl,
	}),
);

export const updateStatementArticle = createAction(
	'[Statement State] - Update Statement Article',
	props<{ statement: StatementArticle }>(),
);
